import { DataGridFeatureConfig } from '@waseel-asp/tpa-waseel-lib-staging';
import { GRID_PAGE_DEFAULT_SIZE, GRID_PAGE_SIZE_LIST } from "./grid-constant";

export const defaultGridFeatures: DataGridFeatureConfig<any> = {
  isRowHoverEnable: true,
  showPagination: true,
  enableApiSearching: true,
  enableApiSorting: true,
  allowSearching: true,
  allowSorting: true,
  allowHideShowColumns: true,
  allowExpandRow: false,
  showCheckboxSelection: false,
  stickyFeature: {
    isStickyHeader: true
  },
  paginatorFeatures: {
    pageSizeOptions: GRID_PAGE_SIZE_LIST,
    defaultPagesize: GRID_PAGE_DEFAULT_SIZE,
    totalCount: 0,
    currentPageIndex: 0,
    enableApiPagination: true
  }
};